/**
 * Created by coolguy on 2018/8/30.
 */
var request = require('../utils/request.js');

const comment = {
    //删除
    del:(id)=>{
        return new Promise((resolve,reject)=>{
            request({
                url:'/api/comment/destroy',
                method:'post',
                data:{id}
            }).then(jsonData=>{
                resolve(jsonData);
            }).catch(reject);
        })
    },
    post: ({content,galleryid}) => {
        return new Promise((resolve, reject)=>{
            request({
                url:'/api/comment/post',
                method:'post',
                data:{content,galleryid},
            }).then((jsonData) => {
                resolve(jsonData);
            }).catch(reject);
        });
    },
    list: (galleryid,id,time=0) => {
        return new Promise((resolve, reject) => {
            request({
                url: '/api/comment/list',
                data:{galleryid,time,pagesize:50},
            }).then(res => {
                resolve(res);
            }).catch(reject)
        });
    },
    top: (galleryid)=>{
        return new Promise((resolve, reject)=>{
            request({
                url:'/api/comment/gallery/top',
                data:{
                    galleryid
                }
            }).then(res=>{
                resolve(res);
            }).catch(reject);
        });
    },
    my: (galleryid) => {
        return new Promise((resolve,reject)=>{
            request({
                url:'/api/comment/my',
                data:{galleryid}
            }).then( res => {
                resolve(res)
            }).catch(reject);
        })
    }
};

module.exports = comment;



// WEBPACK FOOTER //
// ./src/actions/videoComment.js